package org.example.zone360.pages.coachDetails.coachInfo

import org.example.zone360.components.debugPrintln

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateListOf
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.ObjectFit
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.WhiteSpace
import com.varabyte.kobweb.compose.css.WordBreak
import com.varabyte.kobweb.compose.css.functions.LinearGradient
import com.varabyte.kobweb.compose.css.functions.linearGradient
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.backgroundImage
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.flexWrap
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.left
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.objectFit
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.rowGap
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.icons.fa.FaBriefcase
import com.varabyte.kobweb.silk.components.icons.fa.FaCheck
import com.varabyte.kobweb.silk.components.icons.fa.FaEnvelope
import com.varabyte.kobweb.silk.components.icons.fa.FaFlag
import com.varabyte.kobweb.silk.components.icons.fa.FaLayerGroup
import com.varabyte.kobweb.silk.components.icons.fa.IconSize
import com.varabyte.kobweb.silk.components.icons.fa.IconStyle
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import org.example.zone360.utils.getAllTeams
import org.example.zone360.utils.getSingleCoach
import kotlinx.browser.document
import kotlinx.browser.window
import kotlinx.coroutines.CancellationException
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch
import org.example.zone360.components.CommonDropdown
import org.example.zone360.components.CustomDivider
import org.example.zone360.components.CustomSpacer
import org.example.zone360.components.OptionalInputField
import org.example.zone360.components.ProgressIndicator
import org.example.zone360.components.ShimmerCircle
import org.example.zone360.components.TeamTokenSearchForInfo
import org.example.zone360.components.formatSessionMinutes
import org.example.zone360.components.showToast
import org.example.zone360.componentss.FieldTitleTextNormalSimple
import org.example.zone360.models.GetSingleCoachData
import org.example.zone360.theme.Palette
import org.example.zone360.theme.SitePalette
import org.example.zone360.utils.AppGlobal
import org.example.zone360.utils.Constants
import org.example.zone360.utils.Res
import org.example.zone360.utils.SelectedData
import org.example.zone360.utils.Strings
import org.example.zone360.utils.ToastID
import org.example.zone360.utils.extractTeamName
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.FlexWrap
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.deg
import org.jetbrains.compose.web.css.display
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Img
import org.jetbrains.compose.web.dom.Input
import org.w3c.dom.HTMLInputElement
import org.w3c.files.FileReader
import org.example.zone360.utils.updateUserData
import org.example.zone360.utils.uploadCoachImage

@Composable
fun CoachInfo(
    breakpoint: Breakpoint,
    sitePalette: SitePalette,
    userId: String,
    selectedSession: SelectedData,
    message: (String) -> Unit,
    team: (List<String>) -> Unit = {},
    getCoachInfo: GetSingleCoachData,
    showInfoOverlay: (Boolean) -> Unit = {},
    coachData: (GetSingleCoachData) -> Unit,
    isLoading: Boolean,
    disable: Boolean,
) {
    val scope = rememberCoroutineScope()
    var getSingleCoachData by remember { mutableStateOf(GetSingleCoachData()) }
    var nationality by remember { mutableStateOf("") }
    var job by remember { mutableStateOf("") }
    var level by remember { mutableStateOf("") }
    var selectedLevel by remember { mutableStateOf("Select Level") }
    var isSavingPicture by remember { mutableStateOf(false) }
    var isNationalityEditing by remember { mutableStateOf(false) }
    var isJobEditing by remember { mutableStateOf(false) }
    var isLevelEditing by remember { mutableStateOf(false) }
    var teamManagementEditing by remember { mutableStateOf(false) }
    var isAllEditing by remember { mutableStateOf(false) }
    var isUpdateLoading by remember { mutableStateOf(false) }
    var isImageUploading by remember { mutableStateOf(false) }
    var teamManagement by remember { mutableStateOf("") }
    val selectedTeams = remember { mutableStateListOf<String>() }
    var uploadedImageUrl by remember { mutableStateOf<String?>(null) }

    val speaking = if (getSingleCoachData.recordTime > 0) {
        ((getSingleCoachData.speakingTime / (getSingleCoachData.recordTime / 1000.0)) * 100).toInt()
    } else {
        0
    }

    val apiSessionType = when (selectedSession) {
        SelectedData.Matches -> Strings.MATCH
        SelectedData.Training -> Strings.TRAINING
    }
    LaunchedEffect(teamManagement) {
        if (selectedTeams.isNotEmpty()) {
            team(selectedTeams.toList())
        }
    }
    scope.launch {
        getSingleCoachData = getCoachInfo
        coachData(getSingleCoachData)

        nationality = getSingleCoachData.nationality
        job = getSingleCoachData.job
        level = getSingleCoachData.level
        selectedLevel = getSingleCoachData.level.ifEmpty { "Select Level" }

        val teams = getSingleCoachData.teams ?: emptyList()
        teamManagement = teams.joinToString(", ") { it.teamID.extractTeamName() }
        if (!teamManagementEditing) {
            selectedTeams.clear()
            selectedTeams.addAll(teams.map { it.teamID })
        }
    }

    LaunchedEffect(Unit) {
        scope.launch {
            try {
                val response = getAllTeams(
                    clubName = AppGlobal.userData.organization,
                    seasonID = AppGlobal.selectedSeasonId
                )
                AppGlobal.teamDataList.clear()
                AppGlobal.teamDataList.addAll(response.data)
            } catch (e: Exception) {
                console.error("Error fetching teams:", e)
            }
        }
    }
    LaunchedEffect(getSingleCoachData.imageUrl) {
        if (getSingleCoachData.imageUrl.isNotBlank()) {
            val jsImg = js("new Image()")
            jsImg.crossOrigin = "anonymous"
            jsImg.src =
                "${Res.Images.base_Image_Url}${getSingleCoachData.imageUrl}?nocache=${js("Date.now()")}"

            jsImg.onload = {
                uploadedImageUrl = jsImg.src as String
            }

            jsImg.onerror = {
                uploadedImageUrl = Res.Images.userIconSquare // fallback image
            }
        } else {
            uploadedImageUrl = Res.Images.userIconSquare
        }
    }
    fun isCoachProfileComplete(profile: GetSingleCoachData): Boolean {
        return profile.nationality.isNotBlank() &&
                profile.level.isNotBlank() &&
                profile.job.isNotBlank()
    }
    LaunchedEffect(getCoachInfo) {
        val completed = isCoachProfileComplete(getCoachInfo)
        showInfoOverlay(!completed)
        console.log("Coach profile completed: $completed")
    }
    fun captureScreenshot() {
        isSavingPicture = true
        // Close all edit modes
        isNationalityEditing = false
        isJobEditing = false
        isLevelEditing = false
        teamManagementEditing = false

        scope.launch {
            delay(100)
            captureElementAsPng(
                elementId = Res.Id.coachInfoHeader,
                fileName = "${getSingleCoachData.firstName}_${getSingleCoachData.lastName}"
            )
            isSavingPicture = false
        }
    }
    Box(
        modifier = Modifier
            .fillMaxWidth()
            .borderRadius(11.34.px)
            .overflow(
                overflowY = Overflow.Hidden,
                overflowX = Overflow.Auto
            )
            .backgroundImage(
                linearGradient(
                    LinearGradient.Direction.ToRight,
                    sitePalette.coachHeaderGradientOne.rgb,
                    sitePalette.coachHeaderGradientTwo.rgb
                )
            )
    ) {
        Box(
            modifier = Modifier
                .width(100.percent)
                .padding(leftRight = 10.px)
        ) {
            Column(
                modifier = Modifier
                    .fillMaxWidth()
                    .flexWrap(if (isSavingPicture) FlexWrap.Wrap else FlexWrap.Nowrap)
                    .fillMaxHeight(),
                horizontalAlignment = Alignment.CenterHorizontally
            ) {
                Box(
                    modifier = Modifier.width(98.8.percent)
                        .fillMaxHeight(),
                    contentAlignment = Alignment.Center
                ) {
                    Column(
                        modifier = Modifier.fillMaxWidth()

                            .padding(topBottom = 20.px)
                    ) {
                        Row(
                            modifier = Modifier.fillMaxWidth()
                                .padding(leftRight = if (breakpoint < Breakpoint.MD) 6.px else 15.px)
                                .flexWrap(FlexWrap.Wrap)
                                .gap(24.px),
                            horizontalArrangement = Arrangement.SpaceBetween
                        ) {
                            if (window.screen.width < 1330) {
                                Row(
                                    modifier = Modifier.fillMaxWidth().flexWrap(FlexWrap.Wrap)
                                        .gap(10.px),
                                    verticalAlignment = Alignment.CenterVertically
                                ) {
                                    Box {
                                        if (AppGlobal.userData.uid == getSingleCoachData.uid) {
                                            Row(
                                                Modifier.fillMaxWidth()
                                                    .zIndex(888),
                                                horizontalArrangement = Arrangement.End
                                            ) {
                                                if (!isImageUploading) {
                                                    Image(
                                                        src = Res.Images.camera_icon,
                                                        modifier = Modifier.width(33.px)
                                                            .cursor(Cursor.Pointer)
                                                            .margin(right = (-10).px, top = (-8).px)
                                                            .onClick {
                                                                val input =
                                                                    document.getElementById(Res.Id.coachImage) as? HTMLInputElement
                                                                input?.click()
                                                            }
                                                    )
                                                }
                                            }
                                        }
                                        Box(
                                            modifier = Modifier
                                                .width(217.px)
                                                .height(217.px)
                                                .backgroundImage(
                                                    linearGradient(
                                                        90.deg,
                                                        sitePalette.coachHeaderGradientOne.rgb,
                                                        sitePalette.coachHeaderGradientTwo.rgb
                                                    )
                                                )
                                                .padding(7.23.px)
                                                .borderRadius(12.px),
                                            contentAlignment = Alignment.Center
                                        ) {
                                            when {
                                                isImageUploading -> {
                                                    ShimmerCircle(
                                                        modifier = Modifier.size(217.px).zIndex(999)
                                                            .borderRadius(12.px)
                                                    )
                                                }

                                                uploadedImageUrl != null -> {
                                                    // Show preview if present, even if imageUrl is blank (for first upload)
                                                    Img(
                                                        src = uploadedImageUrl
                                                            ?: Res.Images.userIconSquare,
                                                        alt = "Coach Image",
                                                        attrs = Modifier
                                                            .width(100.percent)
                                                            .height(100.percent)
                                                            .borderRadius(12.px)
                                                            .objectFit(ObjectFit.Cover)
                                                            .toAttrs()
                                                    )
                                                }

                                                getSingleCoachData.imageUrl.isBlank() -> {
                                                    Image(
                                                        src = Res.Images.userIconSquare,
                                                        modifier = Modifier.fillMaxWidth()
                                                            .fillMaxHeight().borderRadius(12.px)
                                                    )
                                                }

                                                else -> {
                                                    Img(
                                                        src = "${Res.Images.base_Image_Url}${getSingleCoachData.imageUrl}",
                                                        alt = "Coach Image",
                                                        attrs = Modifier
                                                            .width(100.percent)
                                                            .height(100.percent)
                                                            .borderRadius(12.px)
                                                            .objectFit(ObjectFit.Cover)
                                                            .toAttrs()
                                                    )
                                                }
                                            }
                                        }

                                    }
                                    Column {
                                        FieldTitleTextNormalSimple(
                                            text = "${getSingleCoachData.firstName.replaceFirstChar { it.uppercase() }} ${getSingleCoachData.lastName.replaceFirstChar { it.uppercase() }}",
                                            fontSize = 20.px,
                                            fontWeight = 600,
                                            fontFamily = Constants.IBM_FONT,
                                            color = Palette.White.rgbLight,
                                            wordBreak = WordBreak.BreakAll
                                        )
                                        Row(
                                            modifier =
                                                Modifier.margin(bottom = 8.px)
                                                    .fillMaxWidth(),
                                            verticalAlignment = Alignment.CenterVertically
                                        ) {

                                            FieldTitleTextNormalSimple(
                                                text = AppGlobal.userData.organization.uppercase(),
                                                fontSize = 16.px,
                                                fontWeight = 400,
                                                marginTop = (-4).px,
                                                fontFamily = Constants.IBM_FONT,
                                                color = Palette.White.rgbLight,
                                                whiteSpace = WhiteSpace.PreWrap,
                                            )
                                        }
                                    }
                                }
                            } else {
                                Column(
                                    modifier = Modifier.fillMaxWidth(16.percent),
                                    horizontalAlignment = Alignment.CenterHorizontally
                                ) {
                                    Box {
                                        if (AppGlobal.userData.uid == getSingleCoachData.uid) {
                                            Row(
                                                Modifier.fillMaxWidth()
                                                    .zIndex(999),
                                                horizontalArrangement = Arrangement.End
                                            ) {
                                                if (!isImageUploading) {
                                                    Image(
                                                        src = Res.Images.camera_icon,
                                                        modifier = Modifier.width(33.px)
                                                            .cursor(Cursor.Pointer)
                                                            .margin(right = (-10).px, top = (-8).px)
                                                            .onClick {
                                                                val input =
                                                                    document.getElementById(Res.Id.coachImage) as? HTMLInputElement
                                                                input?.click()
                                                            }
                                                    )
                                                }
                                            }
                                        }
                                        Box(
                                            modifier = Modifier
                                                .width(217.px)
                                                .height(217.px)
                                                .backgroundImage(
                                                    linearGradient(
                                                        90.deg,
                                                        sitePalette.coachHeaderGradientOne.rgb,
                                                        sitePalette.coachHeaderGradientTwo.rgb
                                                    )
                                                )
                                                .padding(7.23.px)
                                                .borderRadius(12.px),
                                            contentAlignment = Alignment.Center
                                        ) {
                                            when {
                                                isImageUploading -> {
                                                    ShimmerCircle(
                                                        modifier = Modifier.size(217.px).zIndex(999)
                                                            .borderRadius(12.px)
                                                    )
                                                }

                                                uploadedImageUrl != null -> {
                                                    // Show preview if present, even if imageUrl is blank (for first upload)
                                                    Img(
                                                        src = uploadedImageUrl
                                                            ?: Res.Images.userIconSquare,
                                                        alt = "Coach Image",
                                                        attrs = Modifier
                                                            .width(100.percent)
                                                            .height(100.percent)
                                                            .borderRadius(12.px)
                                                            .objectFit(ObjectFit.Cover)
                                                            .toAttrs()
                                                    )
                                                }

                                                getSingleCoachData.imageUrl.isBlank() -> {
                                                    Image(
                                                        src = Res.Images.userIconSquare,
                                                        modifier = Modifier.fillMaxWidth()
                                                            .fillMaxHeight().borderRadius(12.px)
                                                    )
                                                }

                                                else -> {
                                                    Img(
                                                        src = "${Res.Images.base_Image_Url}${getSingleCoachData.imageUrl}",
                                                        alt = "Coach Image",
                                                        attrs = Modifier
                                                            .width(100.percent)
                                                            .height(100.percent)
                                                            .borderRadius(12.px)
                                                            .objectFit(ObjectFit.Cover)
                                                            .toAttrs()
                                                    )
                                                }
                                            }
                                        }

                                    }

                                    FieldTitleTextNormalSimple(
                                        text = "${getSingleCoachData.firstName.replaceFirstChar { it.uppercase() }} ${getSingleCoachData.lastName.replaceFirstChar { it.uppercase() }}",
                                        fontSize = 20.px,
                                        fontWeight = 600,
                                        fontFamily = Constants.IBM_FONT,
                                        color = Palette.White.rgbLight,
                                        wordBreak = WordBreak.BreakAll,
                                        marginTop = 16.px
                                    )
                                    Row(
                                        modifier =
                                            Modifier.margin(bottom = 8.px)
                                                .textAlign(TextAlign.Center)
                                                .fillMaxWidth(),
                                        verticalAlignment = Alignment.CenterVertically,
                                        horizontalArrangement = Arrangement.Center
                                    ) {
                                        FieldTitleTextNormalSimple(
                                            text = AppGlobal.userData.organization.uppercase(),
                                            fontSize = 16.px,
                                            fontWeight = 400,
                                            marginTop = (-4).px,
                                            fontFamily = Constants.IBM_FONT,
                                            color = Palette.White.rgbLight,
                                            whiteSpace = WhiteSpace.PreWrap,
                                        )
                                    }


                                }
                            }
                            Column(
                                modifier = Modifier.fillMaxWidth(if (window.screen.width < 1330) 100.percent else 80.percent)
                                    .backgroundColor(sitePalette.coachHeaderDetails.rgb)
                                    .borderRadius(12.px)
                                    .padding(
                                        leftRight =  if (breakpoint < Breakpoint.MD) 15.px else 24.px,
                                        topBottom = if (breakpoint < Breakpoint.MD) 10.px else 24.px
                                    )
                            ) {
                                Row(
                                    modifier = Modifier.fillMaxWidth().gap(30.px),
                                    verticalAlignment = Alignment.CenterVertically,
                                    horizontalArrangement = Arrangement.End
                                ) {
                                    if (!disable) {
                                        if (isUpdateLoading) {
                                            ProgressIndicator(size = 20.px)
                                        } else if (isAllEditing) {
                                            FaCheck(
                                                size = IconSize.LG,
                                                modifier = Modifier.cursor(Cursor.Pointer)
                                                    .color(sitePalette.infoIconColor.rgb)
                                                    .onClick {
                                                        scope.launch {
                                                            try {
                                                                isUpdateLoading = true
                                                                val jsonData = """{
                                                                   "organization": "${AppGlobal.userData.organization}",
                                                                    "uid": "$userId",
                                                                    "nationality": "$nationality",
                                                                     "job": "$job",
                                                                    "level": "$level"
                                                                }"""
                                                                val response =
                                                                    updateUserData(jsonData)
                                                                val res = getSingleCoach(
                                                                    organization = AppGlobal.userData.organization,
                                                                    domainType = "soccer",
                                                                    language = "en",
                                                                    sessionType = apiSessionType,
                                                                    userID = userId,
                                                                    seasonID = AppGlobal.selectedSeasonId
                                                                ).data

                                                                val isComplete =
                                                                    res.job.isNotBlank() &&
                                                                            res.level.isNotBlank() &&
                                                                            res.nationality.isNotBlank()

                                                                showInfoOverlay(!isComplete)
                                                                coachData(res)
                                                                isAllEditing = false
                                                                isNationalityEditing = false
                                                                isJobEditing = false
                                                                isLevelEditing = false
                                                                teamManagementEditing = false
                                                                teamManagement =
                                                                    selectedTeams.joinToString(", ")
                                                            } catch (ce: CancellationException) {
                                                                throw ce
                                                            } catch (e: Exception) {
                                                                message("Failed to update profile")
                                                                showToast(ToastID.ERROR)
                                                            } finally {
                                                                isUpdateLoading = false
                                                            }
                                                        }

                                                    })
                                        } else {
                                            Image(
                                                src = Res.Images.gray_Pencil_Icon,
                                                modifier = Modifier
                                                    .cursor(Cursor.Pointer)
                                                    .onClick {

                                                        isAllEditing = true
                                                        isNationalityEditing = true
                                                        isJobEditing = true
                                                        isLevelEditing = true
                                                        teamManagementEditing = true
                                                    }
                                            )
                                        }
                                    }
                                    if (isSavingPicture) {
                                        ProgressIndicator(size = 20.px)
                                    } else {

                                        Image(
                                            src = Res.Images.share_Nodes,
                                            modifier = Modifier
                                                .cursor(Cursor.Pointer)
                                                .onClick {
                                                    scope.launch {
                                                        val missingFields = mutableListOf<String>()

                                                        if (getCoachInfo.imageUrl.isBlank()) missingFields.add(
                                                            "Profile Image"
                                                        )
                                                        if (getCoachInfo.job.isBlank()) missingFields.add(
                                                            "Job"
                                                        )
                                                        if (getCoachInfo.level.isBlank()) missingFields.add(
                                                            "Level"
                                                        )
                                                        if (getCoachInfo.nationality.isBlank()) missingFields.add(
                                                            "Nationality"
                                                        )

                                                        if (missingFields.isEmpty()) {
                                                            captureScreenshot()
                                                        } else {
                                                            val text = "Please Add: ${
                                                                missingFields.joinToString(", ")
                                                            } to download the image"
                                                            message(text)
                                                            showToast(ToastID.ERROR)
                                                        }
                                                    }
                                                }
                                        )
                                    }
                                }
                                Row(
                                    modifier = Modifier.fillMaxWidth()
                                        .flexWrap(FlexWrap.Wrap),
                                    horizontalArrangement = Arrangement.SpaceBetween
                                ) {
                                    Column(modifier = Modifier.fillMaxWidth(if (breakpoint >= Breakpoint.MD) 70.percent else 100.percent)) {
                                        Row(
                                            Modifier.fillMaxWidth().flexWrap(FlexWrap.Wrap)
                                                .rowGap(if (window.screen.width < 425) 6.px else 10.px),
                                            verticalAlignment = Alignment.CenterVertically,
                                        ) {
                                            Column(modifier = Modifier.gap(6.px)) {
                                                Row(
                                                    modifier = Modifier.flexWrap(FlexWrap.Wrap).margin(topBottom = if (breakpoint < Breakpoint.MD) 5.px else 0.px),
                                                    verticalAlignment = Alignment.CenterVertically
                                                ) {
                                                    FaEnvelope(
                                                        modifier = Modifier.color(Palette.InfoIconColor.rgbLight),
                                                        style = IconStyle.FILLED
                                                    )

                                                    FieldTitleTextNormalSimple(
                                                        text = "Email:   ",
                                                        fontSize = 16.px,
                                                        fontFamily = Constants.IBM_FONT,
                                                        color = sitePalette.coachInfoTextColor.rgb,
                                                        width = if (breakpoint < Breakpoint.MD) 88.px else 0.px,
                                                        marginLeft = 10.px
                                                    )
                                                    CustomSpacer(if (isAllEditing && breakpoint > Breakpoint.LG) 83.px else 0.px)
                                                    FieldTitleTextNormalSimple(
                                                        text = getSingleCoachData.email,
                                                        fontSize = 16.px,
                                                        color = sitePalette.coachInfoTextColor.rgb,
                                                        fontFamily = Constants.IBM_FONT,
                                                        wordBreak = WordBreak.BreakAll

                                                    )
                                                }
                                                Row(
                                                    modifier = Modifier.gap(6.px).flexWrap(
                                                        if (window.innerWidth < 375)
                                                            FlexWrap.Wrap
                                                        else
                                                            FlexWrap.Nowrap
                                                    ),
                                                    verticalAlignment = Alignment.CenterVertically
                                                ) {
                                                    FaLayerGroup(modifier = Modifier.color(Palette.InfoIconColor.rgbLight))
                                                    FieldTitleTextNormalSimple(
                                                        text = " Level:",
                                                        fontSize = 16.px,
                                                        width = if (breakpoint < Breakpoint.MD) 80.px else 0.px,
                                                        fontFamily = Constants.IBM_FONT,
                                                        color = sitePalette.coachInfoTextColor.rgb,
                                                    )
                                                    CustomSpacer(if (isAllEditing && breakpoint > Breakpoint.LG) 80.px else 0.px)
                                                    if (isLevelEditing) {
                                                        Box {
                                                            CommonDropdown(
                                                                data = listOf(
                                                                    "Select Level",
                                                                    "Youth Recreational",
                                                                    "Youth Competitive",
                                                                    "Adult Recreational",
                                                                    "Adult Competitive",
                                                                ),
                                                                onSelect = { selectedItem ->
                                                                    selectedLevel = selectedItem
                                                                    level =
                                                                        if (selectedItem == "Select Level") "" else selectedLevel

                                                                },
                                                                selectedItem = selectedLevel,
                                                                width = if (window.screen.width < 768) 150.px else 170.px,
                                                            )
                                                        }
                                                    } else {
                                                        FieldTitleTextNormalSimple(
                                                            text = level,
                                                            fontSize = 16.px,
                                                            fontFamily = Constants.IBM_FONT,
                                                            color = sitePalette.coachInfoTextColor.rgb,
                                                            wordBreak = WordBreak.BreakAll

                                                        )
                                                    }
                                                }
                                            }
                                            CustomSpacer(if (window.screen.width > 1000) 100.px else if (breakpoint <= Breakpoint.SM) 0.px else 10.px)
                                            Column(modifier = Modifier.gap(4.px)) {
                                                Row(
                                                    modifier = Modifier.gap(6.px).flexWrap(
                                                        if (window.innerWidth < 375)
                                                            FlexWrap.Wrap
                                                        else
                                                            FlexWrap.Nowrap
                                                    ),
                                                    verticalAlignment = Alignment.CenterVertically
                                                ) {
                                                    FaBriefcase(modifier = Modifier.color(Palette.InfoIconColor.rgbLight))
                                                    FieldTitleTextNormalSimple(
                                                        text = " Job:",
                                                        fontSize = 16.px,
                                                        fontFamily = Constants.IBM_FONT,
                                                        width = if (breakpoint < Breakpoint.MD) 82.px else 0.px,
                                                        color = sitePalette.coachInfoTextColor.rgb,
                                                        whiteSpace = WhiteSpace.Normal
                                                    )
                                                    CustomSpacer(if (isJobEditing && breakpoint > Breakpoint.MD) 47.px else 0.px)
                                                    if (isJobEditing) {
                                                        OptionalInputField(
                                                            value = job,
                                                            onValueChange = { job = it },
                                                            placeHolder = "Job",
                                                            backgroundColor = sitePalette.modalBackgroundColor.rgb,
                                                            width = if (breakpoint <= Breakpoint.MD) 150.px else 100.px,
                                                            fontSize = 13.px,
                                                            id = Res.Id.updateJob
                                                        )
                                                    } else {
                                                        FieldTitleTextNormalSimple(
                                                            text = job,
                                                            fontSize = 16.px,
                                                            fontFamily = Constants.IBM_FONT,
                                                            color = sitePalette.coachInfoTextColor.rgb,
                                                            wordBreak = WordBreak.BreakAll

                                                        )
                                                    }
                                                }
                                                CustomSpacer(10.px)

                                                Row(
                                                    modifier = Modifier.flexWrap(
                                                        if (window.innerWidth < 375)
                                                            FlexWrap.Wrap
                                                        else
                                                            FlexWrap.Nowrap
                                                    ),
                                                    verticalAlignment = Alignment.CenterVertically,
                                                    horizontalArrangement = Arrangement.Center
                                                ) {
                                                    FaFlag(
                                                        modifier = Modifier.color(Palette.InfoIconColor.rgbLight),
                                                        style = IconStyle.FILLED
                                                    )
                                                    FieldTitleTextNormalSimple(
                                                        text = "Nationality:   ",
                                                        fontSize = 16.px,
                                                        fontFamily = Constants.IBM_FONT,
                                                        color = sitePalette.coachInfoTextColor.rgb,
                                                        marginLeft = 8.px,
                                                        whiteSpace = WhiteSpace.Normal

                                                    )
                                                    if (isNationalityEditing) {
                                                        OptionalInputField(
                                                            value = nationality,
                                                            placeHolder = "Nationality",
                                                            onValueChange = { nationality = it },
                                                            backgroundColor = sitePalette.modalBackgroundColor.rgb,
                                                            width = if (breakpoint <= Breakpoint.MD) 150.px else 100.px,
                                                            fontSize = 13.px,
                                                            id = Res.Id.updateNationality
                                                        )
                                                    } else {
                                                        FieldTitleTextNormalSimple(
                                                            text = nationality,
                                                            fontSize = 16.px,
                                                            fontFamily = Constants.IBM_FONT,
                                                            color = sitePalette.coachInfoTextColor.rgb,
                                                            wordBreak = WordBreak.BreakAll

                                                        )
                                                    }
                                                }
                                            }

                                        }

                                        if (AppGlobal.userData.organization != Strings.INDEPENDENT) {
                                            Row(
                                                modifier = Modifier.margin(topBottom = 10.px)
                                                    .gap(6.px).flexWrap(
                                                        if (window.innerWidth < 375)
                                                            FlexWrap.Wrap
                                                        else
                                                            FlexWrap.Nowrap
                                                    ),
                                            ) {
                                                Image(src = Res.Images.teamIcon)
                                                FieldTitleTextNormalSimple(
                                                    text = "Teams Managing:",
                                                    fontSize = 16.px,
                                                    width = when {
                                                        window.innerWidth <= 375 -> 102.px
                                                        window.innerWidth in 400..800 -> 84.px
                                                        else -> 130.px
                                                    },
                                                    fontFamily = Constants.IBM_FONT,
                                                    color = sitePalette.coachInfoTextColor.rgb,
                                                )

                                                if (teamManagementEditing) {
                                                    Box(modifier = Modifier.weight(1f)) {
                                                        val teamDataList = AppGlobal.teamDataList.map { it.id }
                                                            .filter { it !in selectedTeams }
                                                        TeamTokenSearchForInfo(
                                                            teams = teamDataList,
                                                            selectedTeams = selectedTeams,
                                                            onTeamSelected = { team ->
                                                                if (!selectedTeams.contains(team)) {
                                                                    selectedTeams.add(team)
                                                                    team(selectedTeams.toList())
                                                                    message("Team added successfully!")
                                                                    showToast("toastSuccess")
                                                                }
                                                            },
                                                            onTeamRemoved = { team ->
                                                                selectedTeams.remove(team)
                                                                team(selectedTeams.toList())
                                                                message("Team removed successfully!")
                                                                showToast("toastSuccess")
                                                            },
                                                            width = if (breakpoint > Breakpoint.LG) 170.px else 150.px,
                                                            userID = userId,
                                                            onDismiss = {
                                                                teamManagementEditing = false
                                                                teamManagement =
                                                                    selectedTeams.joinToString(", ")

                                                            },
                                                            toastMessage = message
                                                        )
                                                    }
                                                    CustomSpacer(20.px)
                                                } else {

                                                    FieldTitleTextNormalSimple(
                                                        text = teamManagement,
                                                        fontSize = 16.px,
                                                        fontFamily = Constants.IBM_FONT,
                                                        color = sitePalette.coachInfoTextColor.rgb,
                                                        marginLeft = 8.px,
                                                        wordBreak = WordBreak.BreakAll
                                                    )
                                                }
                                            }
                                        }
                                        Row(
                                            modifier = Modifier.fillMaxWidth()
                                                .margin(topBottom = 10.px)
                                                .flexWrap(FlexWrap.Wrap),
                                            verticalAlignment = Alignment.CenterVertically,
                                            horizontalArrangement = Arrangement.SpaceBetween
                                        ) {
                                            CoachHeaderSessions(
                                                image = Res.Images.footballicon,
                                                title = "Total Sessions",
                                                data = getSingleCoachData.count.toString(),
                                                sitePalette = sitePalette,
                                                toolTipText = "The total number of trainings and matches sessions recorded by this coach."
                                            )
                                            CoachHeaderSessions(
                                                image = Res.Images.clockIcon,
                                                title = "Minutes Recorded",
                                                data = (getSingleCoachData.recordTime / 1000).formatSessionMinutes(),
                                                sitePalette = sitePalette,
                                                toolTipText = "The total duration of all sessions, calculated in minutes."
                                            )
                                            CoachHeaderSessions(
                                                image = Res.Images.keywordIcon,
                                                title = "No. of Keywords",
                                                data = getSingleCoachData.totalKeywords.toString(),
                                                sitePalette = sitePalette,
                                                toolTipText = "The number of keywords across the coach's sessions."
                                            )

                                        }
                                        Box(
                                            modifier = Modifier.width(90.percent)
                                                .margin(topBottom = 10.px)
                                                .backgroundColor(Colors.LightGray)  // Background track
                                                .borderRadius(8.px)
                                                .height(8.px)
                                        ) {
                                            val progress = speaking.coerceIn(0, 100)
                                            Box(
                                                modifier = Modifier.fillMaxWidth(progress.percent)
                                                    .borderRadius(8.px)
                                                    .backgroundImage(
                                                        linearGradient(
                                                            LinearGradient.Direction.ToTopRight,
                                                            sitePalette.coachHeaderGradientOne.rgb,
                                                            sitePalette.coachHeaderGradientTwo.rgb
                                                        )
                                                    )
                                                    .height(8.px)
                                            )
                                        }
                                        Row(
                                            Modifier.gap(4.px),
                                            verticalAlignment = Alignment.CenterVertically
                                        ) {
                                            Box(
                                                modifier = Modifier.width(10.px).height(10.px)
                                                    .borderRadius(1.67.px)
                                                    .backgroundImage(
                                                        linearGradient(
                                                            LinearGradient.Direction.ToTopRight,
                                                            sitePalette.coachHeaderGradientOne.rgb,
                                                            sitePalette.coachHeaderGradientTwo.rgb
                                                        )
                                                    )
                                            )
                                            FieldTitleTextNormalSimple(
                                                "Speaking: $speaking%",
                                                fontSize = 12.px,
                                                fontWeight = 500,
                                                fontFamily = Constants.IBM_FONT
                                            )
                                        }
                                    }
                                    Column(
                                        modifier = Modifier.fillMaxWidth(if (breakpoint >= Breakpoint.MD) 30.percent else 100.percent),
                                        horizontalAlignment = Alignment.Start
                                    ) {
                                        CoachInfoEmotion(
                                            coachData = getSingleCoachData,
                                            isLoading = isLoading,
                                            breakpoint = breakpoint
                                        )

                                    }
                                }
                            }
                        }

                    }
                }
            }

            Box(
                modifier = Modifier
                    .width(500.px)
                    .height(500.px)
                    .overflow(
                        overflowY = Overflow.Hidden,
                        overflowX = Overflow.Auto
                    )
                    .id(Res.Id.coachInfoHeader)
                    .position(Position.Absolute)
                    .left((-9999).px)
                    .backgroundImage(
                        linearGradient(
                            LinearGradient.Direction.ToRight,
                            sitePalette.coachHeaderGradientOne.rgb,
                            sitePalette.coachHeaderGradientTwo.rgb
                        )
                    )
            ) {
                Box(
                    modifier = Modifier.fillMaxWidth()
                        .padding(leftRight = 10.px)
                ) {
                    Column(
                        modifier = Modifier
                            .fillMaxWidth(),
                        horizontalAlignment = Alignment.CenterHorizontally
                    ) {
                        Box(
                            modifier = Modifier.fillMaxWidth(),
                            contentAlignment = Alignment.Center
                        ) {
                            Column(
                                modifier = Modifier.fillMaxWidth()
                                    .padding(top = 20.px)
                            ) {
                                Row(
                                    modifier = Modifier.fillMaxWidth(),
                                    verticalAlignment = Alignment.CenterVertically,
                                    horizontalArrangement = Arrangement.Center
                                ) {
                                    Box {
                                        Box(
                                            modifier = Modifier
                                                .width(140.px)
                                                .height(140.px)
                                                .backgroundImage(
                                                    linearGradient(
                                                        90.deg,
                                                        sitePalette.coachHeaderGradientOne.rgb,
                                                        sitePalette.coachHeaderGradientTwo.rgb
                                                    )
                                                )
                                                .padding(3.23.px)
                                                .borderRadius(100.px),
                                            contentAlignment = Alignment.Center
                                        ) {

                                            if (getSingleCoachData.imageUrl.isBlank()) {

                                                Image(
                                                    src = Res.Images.userIconSquare,
                                                    modifier = Modifier.fillMaxWidth()
                                                        .fillMaxHeight()
                                                        .borderRadius(100.percent)
                                                )

                                            } else {
                                                val imageSrc = uploadedImageUrl
                                                    ?: "${Res.Images.base_Image_Url}${getSingleCoachData.imageUrl}"
                                                Img(
                                                    src = imageSrc,
                                                    alt = "Coach Image",
                                                    attrs = Modifier
                                                        .width(100.percent)
                                                        .height(100.percent)
                                                        .borderRadius(100.percent)
                                                        .objectFit(ObjectFit.Cover)
                                                        .toAttrs()
//                                                      .toAttrs {
//                                                            attr("crossorigin", "anonymous")
//                                                        }
                                                )


                                            }

                                        }

                                    }

                                    CustomSpacer(13.px)
                                    Column(
                                        modifier = Modifier.weight(1f).gap(5.px)
                                    ) {
                                        Row(
                                            modifier = Modifier.gap(6.px).fillMaxWidth(),
                                            verticalAlignment = Alignment.CenterVertically,
                                        ) {
                                            val coachFullName =
                                                "${getSingleCoachData.firstName} ${getSingleCoachData.lastName}"
                                            FieldTitleTextNormalSimple(
                                                width = 100.percent,
                                                text = coachFullName.truncateWithEllipsis(400, 32),
                                                fontSize = 32.px,
                                                fontWeight = 500,
                                                fontFamily = Constants.IBM_FONT,
                                                color = Palette.White.rgbLight,
                                                wordBreak = WordBreak.BreakAll,

                                                )
                                        }
                                        Row(
                                            modifier = Modifier.fillMaxWidth(),
                                            verticalAlignment = Alignment.CenterVertically
                                        ) {
                                            FieldTitleTextNormalSimple(
                                                text = AppGlobal.userData.organization.uppercase(),
                                                fontSize = 16.px,
                                                fontFamily = Constants.IBM_FONT,
                                                color = Palette.White.rgbLight,
                                                width = 90.percent
                                            )
                                        }
                                    }
                                }

                                CustomSpacer(height = 35.px)
                                Column(
                                    modifier = Modifier.fillMaxWidth().weight(1f)
                                        .padding(leftRight = 20.px)
                                )
                                {
                                    Column(
                                        modifier = Modifier.fillMaxWidth().height(220.px)
                                            .backgroundColor(sitePalette.coachHeaderDetails.rgb)
                                            .borderRadius(12.px),
                                        verticalArrangement = Arrangement.SpaceEvenly
                                    ) {
                                        Row(
                                            Modifier.gap(10.px).fillMaxWidth()
                                                .padding(leftRight = 20.px, topBottom = 10.px)
                                        ) {
                                            Row(
                                                modifier = Modifier.gap(6.px).weight(1f),
                                                verticalAlignment = Alignment.CenterVertically,
                                            ) {
                                                FaFlag(
                                                    modifier = Modifier.color(Palette.InfoIconColor.rgbLight),
                                                    style = IconStyle.FILLED
                                                )
                                                FieldTitleTextNormalSimple(
                                                    width = 70.px,
                                                    text = nationality.truncateWithEllipsis(70, 14),
                                                    fontSize = 14.px,
                                                    fontFamily = Constants.IBM_FONT,
                                                    color = sitePalette.coachInfoTextColor.rgb,
                                                    whiteSpace = WhiteSpace.NoWrap,
                                                )
                                            }

                                            Row(
                                                modifier = Modifier.gap(6.px).weight(1f),
                                                verticalAlignment = Alignment.CenterVertically
                                            ) {
                                                FaLayerGroup(
                                                    modifier = Modifier.color(Palette.InfoIconColor.rgbLight)
                                                        .margin(left = (-1).px)
                                                )
                                                FieldTitleTextNormalSimple(
                                                    text = level,
                                                    fontSize = 14.px,
                                                    fontFamily = Constants.IBM_FONT,
                                                    color = sitePalette.coachInfoTextColor.rgb,
                                                )
                                            }
                                            Row(
                                                modifier = Modifier.gap(6.px).weight(1f),
                                                verticalAlignment = Alignment.CenterVertically
                                            ) {
                                                FaBriefcase(modifier = Modifier.color(Palette.InfoIconColor.rgbLight))
                                                FieldTitleTextNormalSimple(
                                                    width = 80.px,
                                                    text = job.truncateWithEllipsis(80, 14),
                                                    fontSize = 14.px,
                                                    fontFamily = Constants.IBM_FONT,
                                                    color = sitePalette.coachInfoTextColor.rgb,
                                                    whiteSpace = WhiteSpace.NoWrap,
                                                )
                                            }
                                        }
                                        if (AppGlobal.userData.organization != Strings.INDEPENDENT) {
                                            Row(
                                                modifier = Modifier.fillMaxWidth().gap(6.px)
                                                    .margin(top = 5.px)
                                                    .padding(leftRight = 20.px),
                                                verticalAlignment = Alignment.CenterVertically
                                            ) {
                                                Image(
                                                    src = Res.Images.teamIcon,
                                                    modifier = Modifier.size(14.px)
                                                )
                                                FieldTitleTextNormalSimple(
                                                    text = teamManagement,
                                                    fontSize = 14.px,
                                                    fontFamily = Constants.IBM_FONT,
                                                    color = sitePalette.coachInfoTextColor.rgb,
                                                    wordBreak = WordBreak.BreakAll,
                                                )
                                            }
                                        }
                                        CustomSpacer(height = 10.px)

                                        CustomDivider(height = 0.7.px)
                                        CustomSpacer(height = 5.px)

                                        Column(Modifier.fillMaxWidth().padding(leftRight = 20.px)) {
                                            CoachInfoEmotion(
                                                coachData = getSingleCoachData,
                                                isLoading = isLoading,
                                                isSaving = true,
                                                breakpoint = breakpoint
                                            )

                                        }
                                    }
                                    Row(
                                        modifier = Modifier.fillMaxWidth()
                                            .margin(topBottom = 10.px),
                                        horizontalArrangement = Arrangement.End
                                    ) {
                                        Image(src = Res.Images.website_logo_zone360_trans)
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
    Input(
        type = InputType.File,
        attrs = {
            id(Res.Id.coachImage)
            attr("accept", "image/*")
            style { display(DisplayStyle.None) }
            onChange { event ->
                val file = (event.target as HTMLInputElement).files?.item(0)

                if (file != null) {
                    // Optional: Preview image in UI
                    val reader = FileReader()
                    reader.onload = { e ->
                        val base64 = e.target?.asDynamic()?.result as? String
                        if (base64 != null) {
                            uploadedImageUrl = base64 // your mutable state
                        }
                    }
                    reader.readAsDataURL(file)

                    // Upload to server
                    scope.launch {
                        isImageUploading = true
                        try {
                            val response = uploadCoachImage(
                                userID = AppGlobal.userData.uid,
                                file = file,
                                organization = AppGlobal.userData.organization
                            )
                            val newUrl = response.data.imageUrl
                            AppGlobal.imageUrl = newUrl
                            AppGlobal.imageVersion++

                            AppGlobal.userData =
                                AppGlobal.userData.copy(imageUrl = newUrl) // ✅ sync with localStorage

                        } catch (e: Exception) {
                            debugPrintln("❌ Upload failed: $e")
                        } finally {
                            isImageUploading = false
                        }
                    }
                }
            }
        }
    )


}


// Simplified capture function
fun captureElementAsPng(elementId: String, fileName: String = "screenshot") {
    val element = document.getElementById(elementId)
    if (element != null) {
        js(
            """
            html2canvas(element, {
                useCORS: true,
                allowTaint: false,
                logging: true,
                scale: 3
            }).then(function(canvas) {
                var link = document.createElement('a');
                link.download = fileName + '.png';
                link.href = canvas.toDataURL('image/png');
                link.click();
            }).catch(function(error) {
                console.error('html2canvas error:', error);
            });
        """
        )
    }
}

fun String?.truncateWithEllipsis(availableWidth: Int = 90, fontSize: Int = 14): String {
    if (this.isNullOrBlank()) return ""  // ← handles null and blank
    if (availableWidth <= 0 || fontSize <= 0) return this  // ← handles invalid params

    val charsPerPixel = 0.55
    val maxChars = (availableWidth / (fontSize * charsPerPixel)).toInt()
        .coerceAtLeast(1) // ← never goes below 1

    return if (this.length > maxChars) this.take(maxChars) + "..." else this
}
